var product = "Shirts";
var productType = "";
// let productDetails = {};
$(".initTryon").each(function () {
  $(this).css("display", "none");
});

$(document).ready(function () {
  $("body").append(
    `<div class="q3d_popup" id="q3d_popup" style="display: none;"></div>`
  );

  let pluginObj = "";
  // set the product type
  //let productType = "shirt";
  var pluginload = false;
  //   loadPluginObj();
  function loadPluginObj(callback, url, g_number) {
    pluginObj = new TdsApp({
      ServiceUrl: "https://ttpv.dam3d.in",
      OrganisationId: 3178977119,
      defaultThreeDImage: undefined, //'1296856912',
      texture: undefined, //'https://s3.ap-south-1.amazonaws.com/aws.tds/tds_textronics/4232835417/z/NTMPLaz.jpg',
      twidth: undefined, //"26.04",
      theight: undefined, //"25.65",
      productName: productType,
      appendContainerDiv: "q3d_popup",
      appendContainerDivWidth: "", //plugin container width
      appendContainerDivHeight: "", //plugin container Height
      displayUI: true,
      loadPlugin: function (obj) {
        pluginObj = obj;
        console.log("Plugin Loaded");
        pluginload = true;
        callback(url, g_number);
        if (
          screen.availWidth < 1024 ||
          window.matchMedia("(orientation: portrait)").matches
        ) {
          resizeObserver.observe(divElement);
        }
        //setTimeout(() => {
        // loadFabric();
        // $("#q3d_popup").css("display", "none");
        // }, 5000);
      },
    });
  }

  function loadFabric(element1, g_number) {
     $("#q3d_popup").css("display", "block");
  $("#q3d_popup").css("visibility", "visible");

  let width = selectedFabricWidth;
  let height = selectedFabricHeight;

  pluginObj.setImageUrl(element1, width, height);

  pluginObj.groupList();
  pluginObj.LoadDrapeFabric(g_number);

  q3d_plugin_size();
  }

  //get q3d image
  function get_q3d_image() {
    // DrapeImage = "https:" + $(".product__media img").first().attr("src");
    DrapeImage = window.productDetails.q3dImage;
    if (DrapeImage === "") {
      alert(
        "Please ensure at least one product image has alt text in the format (q3d_drape_image)."
      );
      return;
    }
    console.log(DrapeImage);
    return DrapeImage;
  }

  function q3d_plugin_size(callback) {
    if (
      screen.availWidth < 1024 ||
      window.matchMedia("(orientation: portrait)").matches
    ) {
      q3d_div_width = Math.round(window.innerWidth);
      q3d_div_height = Math.round(window.innerHeight);
    } else {
      q3d_div_width = screen.availWidth * 0.25;
      q3d_div_height = screen.availHeight * 0.7;
    }
    $("#q3d_popup").css("width", q3d_div_width + "px");
    $("#q3d_popup").css("height", q3d_div_height + "px");
    // document.querySelector("#q3d_popup").style.top = `calc(100vh - ${q3d_div_height}px)`;
    if (callback) {
      callback();
    }
  }

  function q_modelheight() {
    let q3d_popup = document.querySelector(".q3d_popup");
    let branding = document.querySelector(".textronic_brand");
    let _menu_btn = document.querySelector(".q3d_menu_btn");
    let model = document.querySelector(".q3d_model");
    let m_element =
      q3d_popup.offsetHeight - (branding.offsetHeight + _menu_btn.offsetHeight);
    model.style.height = `${m_element}px`;
  }

  window.addEventListener("resize", (event) => {
    if (
      screen.availWidth < 1024 ||
      window.matchMedia("(orientation: portrait)").matches
    ) {
      q3d_plugin_size();
    }
  });

  const divElement = document.querySelector("#q3d_popup");
  const resizeObserver = new ResizeObserver((entries) => {
    entries.forEach((entry) => {
      console.log("Div size changed:", entry.contentRect);
      q3d_plugin_size(q_modelheight);
    });
  });
  $("body").on("click", "#q3d_btn", function (event) {
    // q3d_plugin_size();
    // let DrapeImage = get_q3d_image();
    // productType = window.productDetails.product_type;
    // // console.log('DrapeImage',DrapeImage);
    // if (!pluginload) {
    //   $(".q3d_popup").css("display", "block");
    //   if (productType === "suit") {
    //     loadPluginObj(loadFabric, DrapeImage, 1);
    //   }
    //   loadPluginObj(loadFabric, DrapeImage, 2);
    //   return;
    // }
    // let group_no = $("#groupInfo .group.active").attr("groupno");
    // let g_no = Number(group_no) + 1;
    // loadFabric(DrapeImage, g_no);



  selectedFabricWidth = parseFloat($(this).attr("data-fabric-width"));
  selectedFabricHeight = parseFloat($(this).attr("data-fabric-height"));

  // ✅ Fallback default
  if (isNaN(selectedFabricWidth)) selectedFabricWidth = 2.4;
  if (isNaN(selectedFabricHeight)) selectedFabricHeight = 2.8;

  console.log("Width:", selectedFabricWidth);
  console.log("Height:", selectedFabricHeight);

  q3d_plugin_size();

  let DrapeImage = get_q3d_image();
  productType = window.productDetails.product_type;

  if (!pluginload) {
    $(".q3d_popup").css("display", "block");

    if (productType === "suit") {
      loadPluginObj(loadFabric, DrapeImage, 1);
    }

    loadPluginObj(loadFabric, DrapeImage, 2);
    return;
  }

  let group_no = $("#groupInfo .group.active").attr("groupno");
  let g_no = Number(group_no) + 1;
    loadFabric(DrapeImage, g_no, selectedFabricWidth, selectedFabricHeight);
  // loadFabric(DrapeImage, g_no);


  });

  // get product libery name

  function q3d_getProductMetaData(product_item_id) {
    fetch(`https://shopify.textronic.in/fab3d.php?PRODUCT=${product_item_id}`)
      .then((response) => response.text())
      .then((result) => {
        var meta = JSON.parse(result);
        meta.data.product.metafields.edges.forEach(function (m, i) {
          if (m.node.key == "product") {
            window.productDetails.product = m.node.value;
          }
          if (m.node.key == "product_type") {
            window.productDetails.product_type = m.node.value;
          }
        });
      })
      .catch((error) => console.error(error));
  }

  if (q3d_templete === "q3d_prduct_page") {
    let product_item_id = window.productDetails.id;
    q3d_getProductMetaData(product_item_id);
  }

  // collection with all products
  async function q3d_getCollectionProductImages() {
    var q3d_collection_info = [];
    globalThis.q3d_collection_info = q3d_collection_info;
    try {
      let product_data = {};
      const collection = await fetch(
        `https://shopify.textronic.in/fab3d.php?COLLECTION=${window.productDetails.id}`
      );
      const collectionList = await collection.json();
      const collectionId = collectionList.data.collection.id.split("/")[4];

      collectionList.data.collection.products.edges.forEach(function (
        element,
        num
      ) {
        console.log(element);
        let p_id = element.node.id.split("/")[4];
        product_data.product_id = p_id;
        let d_image_alt = element.node.images.edges[0].node.altText;

        if (d_image_alt === "q3d_drape_image") {
          let d_image_src = element.node.images.edges[0].node.src;
          product_data.product_drape_image = d_image_src;
          console.log(d_image_src);
          element.node.metafields.edges.forEach(function (metaElement, num) {
            if (metaElement.node.key == "product") {
              let p_name = metaElement.node.value;
              product_data.product_name = p_name;
            }
            if (metaElement.node.key == "product_type") {
              let p_type = metaElement.node.value;
              product_data.product_type = p_type;
            }
          });
        }
        let newProductData = { ...product_data };
        globalThis.q3d_collection_info.push(newProductData);
      });
    } catch (error) {
      console.error(error);
    }
  }

  if (q3d_templete == "q3d_collection_page") {
    console.log("collection page");
    q3d_getCollectionProductImages();
    if (
      window.innerWidth >= 1024 &&
      !(window.screen.width == 1080 && window.screen.height == 1920)
    ) {
      window.addEventListener("load", (event) => {
        setTimeout(() => {
          const buttons = document.querySelectorAll(".q3d_collection_btn");
          if (buttons.length > 0) {
            buttons[0].click();
          } else {
            console.error("No element with class 'q3d_collection_btn' found.");
          }
        }, 1000);
      });
    }
  }

  function getmeta_product_data(product_item_id) {
    var single_product_info = {};
    globalThis.single_product_info = single_product_info;
    for (const element of window.q3d_collection_info) {
      if (product_item_id === element.product_id) {
        single_product_info.q3d_image = element.product_drape_image;
        single_product_info.products = element.product_name;
        single_product_info.product_type = element.product_type;
        break;
      }
    }
  }
  $("body").on("click", ".q3d_collection_btn", function (event) {

        // ✅ Get width & height from button
    selectedFabricWidth = parseFloat($(this).data("fabric-width")) || 2.4;
    selectedFabricHeight = parseFloat($(this).data("fabric-height")) || 2.8;
    if (isNaN(selectedFabricWidth)) selectedFabricWidth = 2.4;
  if (isNaN(selectedFabricHeight)) selectedFabricHeight = 2.8;

    console.log("Width:", selectedFabricWidth);
    console.log("Height:", selectedFabricHeight)

    q3d_plugin_size();
    let DrapeImage = "";
    const pid = $(this).attr("pid");
    getmeta_product_data(pid);
    const obj = window.single_product_info.products;
    DrapeImage = window.single_product_info.q3d_image;
    productType = window.single_product_info.product_type;
    if (!pluginload) {
      $(".q3d_popup").css("display", "block");
      if (productType === "suit") {
        loadPluginObj(loadFabric, DrapeImage, 1);
      }
      loadPluginObj(loadFabric, DrapeImage, 2);
      return;
    }
    let group_no = $("#groupInfo .group.active").attr("groupno");
    let g_no = Number(group_no) + 1;
    // loadFabric(DrapeImage, g_no);
    loadFabric(DrapeImage, g_no, selectedFabricWidth, selectedFabricHeight);
  });
});
